import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=82c2f0f2"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"
import style0 from "./Update.vue?vue&type=style&index=0&id=82c2f0f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports